module.exports = __webpack_public_path__ + "static/media/bar-chart.095def71.svg";